export default {
  form: {
    kfName: "Agent Name",
    time: "Date Range",
    status: "Agent Status",
  },
  table: {
    kfName: "Agent Name",
    status: "Agent Status",
    oprType: "Operation Type",
    duration: "Status Duration",
    createdAt: "Created Time",
    connect: "Connect",
    manualSwitch: "Manual Switch",
    disconnect: "Disconnect",
  },
};
